/**
 * The ordering rule of the `request-access` action, on its own.
 *
 * A leaf module: NO imports, so it can be unit-tested without dragging in
 * supabase-js, the store or React — the same reason `stage.ts` is one.
 * `deal-actions.ts` composes it with the real writes.
 *
 * THE RULE: write the founder's `data_room_access_requests` row FIRST, and move
 * the deal to `awaiting_access` only if that resolved.
 *
 * Both halves shipped broken once, in different files. One button wrote the
 * STAGE and no row — the founder was never asked, and the deal stranded at
 * `awaiting_access`, which deliberately offers no way to re-request. Another
 * wrote the ROW and no stage — so the founder's approval hit
 * respond_to_data_room_request's `AND status = 'awaiting_access'` guard, matched
 * zero rows, and the deal never entered `diligence`.
 *
 * The order is chosen on which failure is survivable: a row with no stage is
 * recoverable (the founder can still answer, and the deal can still be moved);
 * a stage with no row is not.
 */

export async function requestAccessThenMoveStage({
  writeRequestRow,
  moveStage,
  hasDealRow,
}: {
  writeRequestRow: () => Promise<unknown>;
  /** Only called when `hasDealRow` — a raising-feed item has no stage to move. */
  moveStage: () => void;
  hasDealRow: boolean;
}): Promise<void> {
  await writeRequestRow();
  if (hasDealRow) moveStage();
}
